// action
import {
    GET_COUPON_LIST,
    GET_COUPON_LIST_FAIL,
    GET_COUPON_LIST_SUCCESS,
    GET_COUPON_LIST_RESET
} from '../action/getCouponListAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    list: [],
    pagination: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_COUPON_LIST:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_COUPON_LIST_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_COUPON_LIST_SUCCESS:
            console.log("page",action.response)
            return {
                ...state,
                apiState: "success",
                list: action.response.data.data.result,
                pagination: action.response.data.data.pagination,
            }
        case GET_COUPON_LIST_RESET:
            return initialState
        default:
            return state
    }
}